export default __webpack_public_path__ + "static/media/Binding of the Void.45879c5c.jpg";